import start from "api/start";


const api = { start };
export default api;